








import Vue, { PropType } from 'vue';
import { BasePeerGroup, MemberRole } from '@/models';
import RoleSelectorPills, {
  PillConfig
} from '@/components/RoleSelectorPills.vue';

export default Vue.extend({
  components: {
    RoleSelectorPills
  },

  props: {
    activeRoles: Array as PropType<string[]>,
    peerGroup: {
      type: Object as PropType<BasePeerGroup>,
      required: true
    }
  },

  computed: {
    rolesConfig(): PillConfig[] {
      return [
        {
          role: MemberRole.STUDENT,
          roleName: this.peerGroup.roleNameStudent
        },
        {
          role: MemberRole.TEACHER,
          roleName: this.peerGroup.roleNameTeacher
        },
        {
          role: MemberRole.OBSERVER,
          roleName: MemberRole.OBSERVER
        }
      ];
    }
  },

  methods: {
    onChange(role: string) {
      this.$emit('role-change', role);
    }
  }
});
